<template>
  <div class="px-9 lg:mt-9 mt-0 flex flex-wrap">
    <div class="lg:w-3/5 w-full ">
      <div class="lg:px-16 px-6 py-6 lg:py-9 leading-snug justify-center">
        <h1 class=" font-extrabold text-5xl lg:text-6xl leading-tight text-gray-700 dark:text-gray-300">
          Digital Partner that transforms your learning activities.
        </h1>
        <p class="leading-9 text-lg text-gray-500 hidden sm:block">
          A digital learning platform is a piece of software designed to heavily assist during the educational process. ...
        </p>
      </div>
    </div>
    <div class="lg:w-2/5 w-full px-5 ml-auto ">
      <form @submit.prevent="handleSubmit" class=" rounded-lg p-9 bg-gray-800 ">
        <input type="email" placeholder="Email" v-model="email" class=" bg-gray-100 text-sm italic" />
        <input type="password" placeholder="Password" v-model="password" class="bg-gray-100 mb-9 text-sm italic" />
        <div v-if="error" class="error">{{ error }}</div>
        <span class="flex flex-wrap">
          <button v-if="!isPending" class="bg-gray-100 p-1 pl-2 pr-2 rounded-lg  hover:text-cyan-700">Log in</button>
          <router-link :to="{ name: 'Signup' }" class="ml-auto">
            <span>Create Account</span>
          </router-link>
        </span>
        <button v-if="isPending" disabled>Loading...</button>
      </form>
    </div>
  </div>
</template>

<script>
import useLogin from "@/composables/useLogin"
import { ref } from "vue"
import { useRouter } from "vue-router"

export default {
  name: "Home",
  components: {},
  setup() {
    const { error, login, isPending } = useLogin()
    const router = useRouter()

    const email = ref("")
    const password = ref("")

    const handleSubmit = async () => {
      const res = await login(email.value, password.value)
      if (!error.value) {
        router.push({ name: "Dashboard" })
      }
    }

    return { email, password, handleSubmit, error, isPending }
  },
}
</script>
